import { RootState } from 'src/redux/createRootReducer'

export const selectReportDownloadIdFromState = (
  state: RootState,
): string | undefined => state.app.downloadTransactions.reportDownloadId

export const selectPostingReportTransactionsDownloadFromState = (
  state: RootState,
): boolean => state.app.downloadTransactions.postingReportTransactionsDownload

export const selectTopLevelErrorFromState = (
  state: RootState,
): string | undefined => state.app.downloadTransactions.topLevelError
